
<template>
  <router-view />
</template>

<script>
export default {
  name: "app-weekProgram"
};
</script>

<style lang="scss" scoped></style>
